(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["leverdatum"] && !Shopify.designMode) return;
  try {
    (function () {
    function plus(werkdagen) {
      var d = new Date();
      d.setHours(12, 0, 0, 0);
      var n = 0;
      while (n < werkdagen) {
        d.setDate(d.getDate() + 1);
        var w = d.getDay();
        if (w !== 0 && w !== 6) n++;
      }
      return d;
    }
    function bereik(a, b, taal) {
      try {
        var dag = new Intl.DateTimeFormat(taal, { day: 'numeric' });
        var vol = new Intl.DateTimeFormat(taal, { day: 'numeric', month: 'short' });
        if (a.getMonth() === b.getMonth()) {
          // "15–19 okt." (nl) / "15.–20. Okt." (de): Intl zet zelf de punt achter de dag waar die hoort
          return dag.format(a) + '–' + vol.format(b);
        }
        return vol.format(a) + ' – ' + vol.format(b);
      } catch (e) {
        return null;
      }
    }
    function vul(el) {
      if (el.hasAttribute('data-klaar')) return;
      el.setAttribute('data-klaar', '');
      var taal = el.getAttribute('data-taal') || 'nl';
      var tekst = bereik(plus(+el.getAttribute('data-min')), plus(+el.getAttribute('data-max')), taal);
      if (!tekst) return;
      var span = el.querySelector('.leverdatum__tekst');
      if (span) span.textContent = el.getAttribute('data-tekst').replace('[d]', tekst);
    }
    function alles() {
      document.querySelectorAll('[data-leverdatum]:not([data-klaar])').forEach(vul);
    }
    alles();
    document.addEventListener('DOMContentLoaded', alles);
    // De winkelwagen-zijbalk wordt na elke wijziging opnieuw opgebouwd.
    new MutationObserver(alles).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
